
import { library } from '@fortawesome/fontawesome-svg-core';
import { faBell } from '@fortawesome/pro-solid-svg-icons';
import { defineComponent } from 'vue';
import { mapState } from 'vuex';

import formatRuleViolationMessage from '@/activities/ruleCheck/utils/formatRuleViolationMessage';
import type { HexCode } from '@/precision-farming/application-maps/store/baseWorkflowStore/types/Heatmap';
import { ThemeColors } from '@/shared/constants';

library.add(faBell);
const __default__ = defineComponent({
  name: 'AlertLiveCheckContainer',
  props: {
    clickable: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  created(): void {
    this.$store.dispatch('activities/ruleCheck/rules/subscribe');
  },
  data(): {
    bgColor: HexCode;
  } {
    return {
      bgColor: ThemeColors.DANGER,
    };
  },
  computed: {
    showModal: {
      get(): boolean {
        return this.$store.state.precisionFarming.applicationMaps.spraying.showRuleViolationModal;
      },
      set(show: boolean) {
        this.$store.state.precisionFarming.applicationMaps.spraying.showRuleViolationModal = show;
      },
    },
    ...mapState('precisionFarming/applicationMaps/spraying', ['violations']),
    ...mapState('activities/ruleCheck/rules', {
      rules: 'data',
    }),
    violationMessage(): string {
      if (!this.violations.length) {
        return 'Unbekannter Fehler';
      }

      const violation = this.violations[0];
      const rule = this.rules[violation.ruleId];

      if (!rule) {
        return 'Unbekannter Fehler';
      }

      return formatRuleViolationMessage(rule.shortMessage, rule.parameterNames, violation.violationData);
    },
  },
  methods: {
    toggle(): void {
      if (this.clickable) {
        this.showModal = true;
      }
    },
  },
});

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars((_vm, _setup) => ({
  "7eeba50c": (_vm.bgColor)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__